import * as React from "react";
import MediaQueryContext, { initMediaQueryStore } from "@/contexts/MediaQuery";
import { breakpoints, BreakpointRange } from "@/utils/breakpoint";

const MediaQuery = () => {
  const mediaQueryContext = React.useContext(MediaQueryContext) || initMediaQueryStore("sm");

  if (typeof window !== "undefined" && window.matchMedia) {
    React.useEffect(() => {
      const creteMatchMedia = (
        bp: BreakpointRange,
        min?: number,
        max?: number
        // eslint-disable-next-line function-paren-newline
      ): [MediaQueryList, (this: MediaQueryList, eve?: MediaQueryListEvent) => void] => {
        const query = `screen${min ? ` and (min-width: ${min}px)` : ""}${max ? ` and (max-width: ${max}px)` : ""}`;
        const mql = window.matchMedia(query);
        // FIXME: Prettier で function の直後の半角スペースが消されてしまうため、一旦 disable. lint:fix が使用出来るようになったら disable を外す
        // eslint-disable-next-line @typescript-eslint/space-before-function-paren
        const callback = function(this: MediaQueryList) {
          if (mql.matches) mediaQueryContext.update(bp);
        };

        callback.call(mql);
        mql.addListener(callback);

        return [mql, callback];
      };

      const mqls: {
        mql: MediaQueryList;
        callback: (this: MediaQueryList, eve: MediaQueryListEvent) => void;
      }[] = [];

      let oldWidth: number | undefined;
      Object.entries(breakpoints).forEach(([bp, width]) => {
        const [mql, callback] = creteMatchMedia(bp as BreakpointRange, oldWidth, width);

        mqls.push({ mql, callback });
        oldWidth = width;
      });

      const [mql, callback] = creteMatchMedia("over", oldWidth, undefined);
      mqls.push({ mql, callback });

      return () => {
        mqls.forEach(({ mql: mediaQueryList, callback: cb }) => mediaQueryList.removeListener(cb));
      };
    }, []);
  }

  return <></>;
};

export default MediaQuery;
